module.exports = __webpack_public_path__ + "img/epomeno.39bbab6a.svg";